<template>
  <div class="tabs" :class="[size, direction, { single: valores.length == 1 }]">
    <!-- <Transition name="fade" mode="out-in"> -->
    <span :lastKey="title" v-show="title" class="tabs__title">{{ title }}</span>
    <!-- </Transition> -->
    <div class="tabs__items">
      <div
        v-for="(valor, valorIndex) in valores"
        :key="valor.cod ? valor.cod + '-' + valorIndex : valorIndex"
        class="tabs__items__item"
        :class="{
          single: valores.length === 1,
          active: valorSel == (valor.cod || valor),
        }"
        @click="$emit('valor', valor)"
      >
        <!-- <Transition name="fade" mode="out-in"> -->
        <span :lastKey="language" class="tabs__items__item__text">
          {{
            typeof valor.getLiteral === 'function'
              ? valor.getLiteral(language)
              : valor.literal
          }}
        </span>
        <!-- </Transition> -->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Tabs',
  props: {
    direction: {
      type: String,
      default: 'column',
    },
    size: {
      type: String,
      default: 'md',
    },
    language: {
      type: String,
      default: 'es',
    },
    title: {
      type: String,
      default: null,
    },
    valorSel: {
      type: [Number, String],
      default: '',
    },
    valores: {
      type: Array,
      default: [],
    },
    borderRadius: {
      type: String,
      default: '0px',
    },
    textColor: {
      type: String,
      default: 'black',
    },
    activeTextColor: {
      type: String,
      default: 'white',
    },
    hoverTextColor: {
      type: String,
      default: 'white',
    },
    backgroundColor: {
      type: String,
      default: 'white',
    },
    activeBackgroundColor: {
      type: String,
      default: 'black',
    },
    hoverBackgroundColor: {
      type: String,
      default: 'black',
    },
  },
};
</script>

<style lang="scss" scoped>
.tabs {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  width: 100%;
  gap: 10px;
  &__title {
    font-size: 14px;
    font-weight: 400;
  }
  &__items {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    border-radius: v-bind(borderRadius);
    &__item {
      color: v-bind(textColor);
      background-color: v-bind(backgroundColor);
      cursor: pointer;
      display: flex;
      justify-content: center;
      align-items: center;
      width: 100%;
      height: 100%;
      padding: 10px;
      -webkit-transition:
        0.35s ease-in-out color,
        0.35s ease-in-out background-color;
      -moz-transition:
        0.35s ease-in-out color,
        0.35s ease-in-out background-color;
      -ms-transition:
        0.35s ease-in-out color,
        0.35s ease-in-out background-color;
      -o-transition:
        0.35s ease-in-out color,
        0.35s ease-in-out background-color;
      transition:
        0.35s ease-in-out color,
        0.35s ease-in-out background-color;
      &__text {
        font-size: 13px;
      }
      &.single {
        border-radius: v-bind(borderRadius) !important;
      }
      &:first-child {
        border-radius: v-bind(borderRadius) 0px 0px v-bind(borderRadius);
      }
      &:last-child {
        border-radius: 0px v-bind(borderRadius) v-bind(borderRadius) 0px;
      }
      &.active {
        color: v-bind(activeTextColor);
        background-color: v-bind(activeBackgroundColor);
        -webkit-transition:
          0.35s ease-in-out color,
          0.35s ease-in-out background-color;
        -moz-transition:
          0.35s ease-in-out color,
          0.35s ease-in-out background-color;
        -ms-transition:
          0.35s ease-in-out color,
          0.35s ease-in-out background-color;
        -o-transition:
          0.35s ease-in-out color,
          0.35s ease-in-out background-color;
        transition:
          0.35s ease-in-out color,
          0.35s ease-in-out background-color;
      }
      @media (hover: hover) {
        &:not(.active):hover {
          color: v-bind(hoverTextColor);
          background-color: v-bind(hoverBackgroundColor);
          -webkit-transition:
            0.35s ease-in-out background-color,
            0.35s ease-in-out color;
          -moz-transition:
            0.35s ease-in-out background-color,
            0.35s ease-in-out color;
          -ms-transition:
            0.35s ease-in-out background-color,
            0.35s ease-in-out color;
          -o-transition:
            0.35s ease-in-out background-color,
            0.35s ease-in-out color;
          transition:
            0.35s ease-in-out background-color,
            0.35s ease-in-out color;
        }
      }
    }
  }
  &.sm {
    & .tabs {
      &__items {
        &__item {
          padding: 5px;
        }
      }
    }
  }
  &.lg {
    & .tabs {
      &__items {
        &__item {
          padding: 15px;
        }
      }
    }
  }
  &.single {
    flex-direction: row;
    align-items: center;
    & .tabs {
      &__items {
        width: auto;
        &__item {
          cursor: default;
          padding: 7px;
        }
      }
    }
  }
  &.row {
    flex-direction: row;
    align-items: center;
    width: auto;
    & .tabs {
      &__items {
        &__item {
          &__text {
            white-space: nowrap;
          }
        }
      }
    }
  }
}
</style>
